import React from "react";
import DefaultLogoImage from "../../../assets/default_logo.png";
import { Link } from "react-router-dom";
import { EyeIcon } from "@heroicons/react/24/solid";
import { TrashIcon } from "@heroicons/react/24/outline";
import { renderToPlainText } from "common";
import { Input } from "common/src/styles";
import { useCartStorage } from "../../../store";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectInCart(props) {
  var _document, _props$projects$find$, _props$projects$find, _props$projects$find2, _props$matchingEstima;
  const {
    project,
    roundRoutePath
  } = props;
  const focusedElement = (_document = document) === null || _document === void 0 || (_document = _document.activeElement) === null || _document === void 0 ? void 0 : _document.id;
  const inputID = "input-" + props.index;
  const store = useCartStorage();
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "cart-project",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "mb-4 flex flex-col lg:flex-row justify-between sm:px-2 px-2 py-4 rounded-md",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "relative overflow-hidden bg-no-repeat bg-cover  min-w-[64px] w-16 max-h-[64px] mt-auto mb-auto",
          children: [/*#__PURE__*/_jsx("img", {
            className: "inline-block rounded-full",
            src: props.project.projectMetadata.logoImg ? `${process.env.REACT_APP_IPFS_BASE_URL}/ipfs/${props.project.projectMetadata.logoImg}` : DefaultLogoImage,
            alt: "Project Logo"
          }), /*#__PURE__*/_jsx(Link, {
            to: `${roundRoutePath}/${project.grantApplicationId}`,
            children: /*#__PURE__*/_jsx("div", {
              className: "min-w-[64px] rounded-full w-16 max-h-[64px] absolute top-0 right-0 bottom-0 left-0 overflow-hidden bg-fixed opacity-0 hover:opacity-70 transition duration-300 ease-in-out bg-gray-500 justify-center flex items-center",
              children: /*#__PURE__*/_jsx(EyeIcon, {
                className: "fill-gray-200 w-6 h-6 cursor-pointer rounded-full",
                "data-testid": `${project.projectRegistryId}-project-link`
              })
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "pl-6 mt-1 flex flex-col",
          children: [/*#__PURE__*/_jsx(Link, {
            to: `${roundRoutePath}/${project.grantApplicationId}`,
            "data-testid": "cart-project-link",
            children: /*#__PURE__*/_jsx("p", {
              className: "font-semibold text-lg mb-2 text-ellipsis line-clamp-1 max-w-[400px] 2xl:max-w-none",
              children: props.project.projectMetadata.title
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm text-ellipsis line-clamp-3 max-w-[400px] 2xl:max-w-none",
            children: renderToPlainText(props.project.projectMetadata.description).substring(0, 130)
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex sm:space-x-4 space-x-2 h-16 sm:pl-4 pt-3 justify-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "md:hidden sm:w-12"
        }), /*#__PURE__*/_jsx(Input, {
          "aria-label": "Donation amount for project " + props.project.projectMetadata.title,
          id: inputID,
          ...(focusedElement === inputID ? {
            autoFocus: true
          } : {}),
          min: "0",
          value: (_props$projects$find$ = (_props$projects$find = props.projects.find(project => project.projectRegistryId === props.project.projectRegistryId)) === null || _props$projects$find === void 0 ? void 0 : _props$projects$find.amount) !== null && _props$projects$find$ !== void 0 ? _props$projects$find$ : "0",
          type: "number",
          onChange: e => {
            store.updateDonationAmount(props.project.chainId, props.project.roundId, props.project.grantApplicationId, e.target.value);
          },
          className: "w-[100px] sm:w-[80px] text-center border border-black"
        }, inputID), /*#__PURE__*/_jsx("p", {
          className: "m-auto",
          children: props.selectedPayoutToken.code
        }), props.payoutTokenPrice > 0 && /*#__PURE__*/_jsxs("div", {
          className: "m-auto px-2 min-w-max flex flex-col",
          children: [/*#__PURE__*/_jsxs("span", {
            className: "text-sm text-grey-400 ",
            children: ["$", " ", (Number(((_props$projects$find2 = props.projects.find(project => project.projectRegistryId === props.project.projectRegistryId)) === null || _props$projects$find2 === void 0 ? void 0 : _props$projects$find2.amount) || 0) * props.payoutTokenPrice).toFixed(2)]
          }), props.showMatchingEstimate && /*#__PURE__*/_jsxs("span", {
            className: "text-teal-500 italic text-sm hidden sm:inline-block",
            children: ["~", ((_props$matchingEstima = props.matchingEstimateUSD) === null || _props$matchingEstima === void 0 ? void 0 : _props$matchingEstima.toFixed(2)) || 0, " USD"]
          })]
        }), /*#__PURE__*/_jsx(TrashIcon, {
          "data-testid": "remove-from-cart",
          onClick: () => {
            props.removeProjectFromCart(props.project);
          },
          className: "w-5 h-5 m-auto cursor-pointer mb-4"
        })]
      })]
    }), !props.last && /*#__PURE__*/_jsx("hr", {
      className: "border-b-[2px] border-grey-100 mx-4"
    })]
  });
}